import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { StudioSidebarService } from '../../services/studio-sidebar/studio-sidebar.service';
import { RoleLimits, StudioSidebarItem } from '@sc/types';
import { PopoverController } from '@ionic/angular';
import { RolesService } from '../../services/roles/roles.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sc-add-sidebar',
  templateUrl: './add-sidebar.component.html',
  styleUrls: ['./add-sidebar.component.scss'],
})
export class AddSidebarComponent implements OnInit, OnDestroy {
  @Input() index: number;

  sidebars = Array.from(this.studioSidebarService.sidebars.values());
  roleLimits = RoleLimits;

  subs: Subscription[] = [];

  constructor(
    private studioSidebarService: StudioSidebarService,
    private popoverController: PopoverController,
    private rolesService: RolesService
  ) {}
  ngOnInit() {
    this.setupRole();
  }

  setupRole() {
    const sub = this.rolesService.role$.subscribe((role) => {
      if (role < this.roleLimits.RECORDING_READ) {
        this.sidebars = this.sidebars.filter((sidebar) => sidebar.name !== 'recordings');
      }
    });
    this.subs.push(sub);
  }

  addSidebar(sidebar: StudioSidebarItem['appearance']) {
    this.studioSidebarService.addSidebarItem(this.index, sidebar);
    this.popoverController.dismiss();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
